// extracted by mini-css-extract-plugin
export default {"tablet":"699","desktop":"1199","desktop-big":"1599","desktopBig":"1599","formBlue":"#3271AB","errorRed":"#E70000","black":"#000","accessibleGray":"#727272","white":"#fff"};